export const metaData = [
  {
    title: "Fenton Chemicals | Agro Emulsifiers, Fertilizers & Silicone Spreaders",
    description:
      "Explore Fenton Chemicals’ product categories: agro chemicals & emulsifiers, fertilizers, silicone super spreaders, paint additives, and home & industrial cleaning solutions.",
    keywords: [
      "Fenton Chemicals",
      "Agro Emulsifiers",
      "Fertilizers",
      "Silicone Spreaders",
      "Paint Additives",
      "Cleaning Solutions",
      "Industrial Chemicals",
      "Home Cleaning Chemicals"
    ]
  },
  {
    title: "Agro Chemicals, Fertilizers & Cleaning Solutions | Fenton Chemicals",
    description:
      "Premium agro emulsifiers, fertilizers, silicone super spreaders, paint additives, general emulsifiers, and home & industrial cleaning chemicals from Fenton Chemicals.",
    keywords: [
      "Agro Chemicals",
      "Fertilizers",
      "Cleaning Solutions",
      "Silicone Super Spreaders",
      "General Emulsifiers",
      "Home Cleaning",
      "Industrial Cleaning Chemicals",
      "Fenton Chemicals Products"
    ]
  },
  {
    title: "Fenton Chemicals – Emulsifiers, Fertilizers & Industrial Cleaning",
    description:
      "ISO 9001:2015 certified chemical exporter in Indore offering agro chemicals & emulsifiers, liquid fertilizers, silicone spreaders, paint additives, and cleaning product.",
    keywords: [
      "ISO 9001 Certified Chemicals",
      "Chemical Exporter Indore",
      "Agro Emulsifiers",
      "Liquid Fertilizers",
      "Silicone Spreaders",
      "Industrial Cleaning",
      "Paint Additives",
      "Fenton Chemicals"
    ]
  }
];

export default metaData;